export const PAGE_LIST_ACTION = "PAGE_LIST_ACTION";
export const PAGE_LIST_SUCCESS = "PAGE_LIST_SUCCESS";
export const PAGE_LIST_FAIL = "PAGE_LIST_FAIL";
export const PAGE_DETAIL_ACTION = "PAGE_DETAIL_ACTION";
export const PAGE_DETAIL_SUCCESS = "PAGE_DETAIL_SUCCESS";
export const PAGE_DETAIL_FAIL = "PAGE_DETAIL_FAIL";
export const PAGE_FAIL = "PAGE_FAIL";
export const PAGE_DETAIL_UPDATE_ACTION = "PAGE_DETAIL_UPDATE_ACTION";
export const PAGE_DETAIL_CREATE_ACTION = "PAGE_DETAIL_CREATE_ACTION";
export const PAGE_DETAIL_DELETE_ACTION = "PAGE_DETAIL_DELETE_ACTION";

export const PAGE_CREATE_TRANSLATE_ACTION = "PAGE_CREATE_TRANSLATE_ACTION";
export const PAGE_CREATE_TRANSLATE_SUCCESS = "PAGE_CREATE_TRANSLATE_SUCCESS";

export const PAGE_UPDATE_TRANSLATE_ACTION = "PAGE_UPDATE_TRANSLATE_ACTION";
export const PAGE_UPDATE_TRANSLATE_SUCCESS = "PAGE_UPDATE_TRANSLATE_SUCCESS";

export const PAGE_DELETE_TRANSLATE_ACTION = "PAGE_DELETE_TRANSLATE_ACTION";
export const PAGE_DELETE_TRANSLATE_SUCCESS = "PAGE_DELETE_TRANSLATE_SUCCESS";